import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertBar = (props) => {
    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
                open={props.open}
                autoHideDuration={4000}
                onClose={props.closeHandler}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                style={{ marginBottom: props.verticalOffset }}
            >
                <Alert onClose={props.closeHandler} severity={props.severity} sx={{ width: '100%' }}>
                    {props.message}
                </Alert>
            </Snackbar>
        </Stack>
    );
};

export default AlertBar;
